module.exports = __webpack_public_path__ + "img/gain-logo.0bd767c6.png";